import type { UseMutationResult } from '@tanstack/react-query'
import { BoolIcon } from '@/components/common/BoolIcon'
import {
  useTaskActionTypes,
  useCreateTaskActionType,
  useUpdateTaskActionType,
  useDeactivateTaskActionType,
} from '@/features/tasks/hooks'
import type { ActionType } from '@/features/tasks/types'
import type { DictionaryPanelConfig } from '../DictionaryPanel'

export const actionTypesConfig: DictionaryPanelConfig<ActionType> = {
  title: 'Typy akcji',
  description: 'Rodzaje działań w zadaniach (np. Wizyta, Telefon, Email).',
  addLabel: 'Dodaj typ akcji',
  deleteSemantics: 'soft',  // backend: set is_active=false; istniejące taski zachowują snapshot label
  useList: useTaskActionTypes,
  useCreate: () => {
    const m = useCreateTaskActionType()
    return {
      ...m,
      mutate: (payload: Record<string, unknown>, opts?: Parameters<typeof m.mutate>[1]) =>
        m.mutate(
          {
            code: String(payload['code'] ?? ''),
            label: String(payload['label'] ?? ''),
          },
          opts,
        ),
    } as unknown as UseMutationResult<ActionType, Error, Record<string, unknown>>
  },
  useUpdate: () => {
    const m = useUpdateTaskActionType()
    return {
      ...m,
      mutate: (
        vars: { code: string; patch: Record<string, unknown> },
        opts?: Parameters<typeof m.mutate>[1],
      ) =>
        m.mutate(
          { code: vars.code, patch: { label: String(vars.patch['label'] ?? '') } },
          opts,
        ),
    } as unknown as UseMutationResult<ActionType, Error, { code: string; patch: Record<string, unknown> }>
  },
  useDeactivate: useDeactivateTaskActionType,
  columns: [
    { key: 'code', header: 'Kod', className: 'font-mono text-slate-500 w-40' },
    { key: 'label', header: 'Etykieta' },
    { key: 'isActive', header: 'Aktywne', render: (t) => BoolIcon({ value: t.isActive }) },
  ],
  formFields: [
    { key: 'code', label: 'Kod (UPPERCASE)', type: 'code', required: true },
    { key: 'label', label: 'Etykieta', type: 'text', required: true },
  ],
}
